import { doc, getDoc } from "firebase/firestore";
const ctrsteststoresids = [
  "IwsKN48lzJH1ErgSylA9", // 0 -> Jewerly Bulk // "site": "Idol" // https://idol-store.web.app
  "9ZJrz2URrntOEyj8RDug", // 1 -> Fashion Bulk // "site": "fashion-colombia" // https://fashion-colombia.web.app
];

const comodinIdStore = ctrsteststoresids[1]
let storeDocData = {comodinIdStore}

export const storeData = (initializeData = false, store_db) => {
  if (initializeData) {
    return getStoreData(store_db).then((data) => {
      storeDocData = data;
      return storeDocData;
    });
  } else {
    return storeDocData;
  }
};

const getStoreData = async (store_db) => {
  const docRef = doc(store_db, "stores", comodinIdStore);
  let storeDoc = await getDoc(docRef)
  if(storeDoc.exists){
      // console.log(storeDoc.data())
      return storeDoc.data()
  } else {
      return null
  }
}